import { create } from "zustand";
import { ClusterType } from "@/types";

type BareMetalModalStore = {
  isRequestModalOpen: boolean;
  requestModalClusterType?: ClusterType;
  openRequestModal: (type: ClusterType) => void;
  closeRequestModal: () => void;
};

export const useModalStore = create<BareMetalModalStore>((set) => ({
  isRequestModalOpen: false,
  requestModalClusterType: undefined,
  openRequestModal: (type: ClusterType) =>
    set({ isRequestModalOpen: true, requestModalClusterType: type }),
  closeRequestModal: () => set({ isRequestModalOpen: false, requestModalClusterType: undefined })
}));
